const storageKey = (pairingCode: string) => `trinity-kiosk:${pairingCode}`;

export interface KioskGatewayAuth {
  accessToken: string;
  pairingCode: string;
  kioskId: string;
  churchId: string;
}

export const readGatewayAuth = (pairingCode: string): KioskGatewayAuth | null => {
  try {
    const raw = localStorage.getItem(storageKey(pairingCode));
    if (!raw) return null;
    return JSON.parse(raw) as KioskGatewayAuth;
  } catch {
    return null;
  }
};

export const writeGatewayAuth = (auth: KioskGatewayAuth): void => {
  localStorage.setItem(storageKey(auth.pairingCode), JSON.stringify(auth));
};

export const clearGatewayAuth = (pairingCode: string): void => {
  localStorage.removeItem(storageKey(pairingCode));
};

export const displayTokenKey = (pairingCode: string) => `trinity-kiosk-display:${pairingCode}`;

export const writeDisplayToken = (pairingCode: string, token: string): void => {
  sessionStorage.setItem(displayTokenKey(pairingCode), token);
};

export const readDisplayToken = (pairingCode: string): string | null =>
  sessionStorage.getItem(displayTokenKey(pairingCode));

export const clearDisplayToken = (pairingCode: string): void => {
  sessionStorage.removeItem(displayTokenKey(pairingCode));
};

/** Staff "Open kiosk" lands here with `?access=` so the public pairing poll is not reused. */
export const consumeAccessFromUrl = (pairingCode: string): KioskGatewayAuth | null => {
  if (!pairingCode || typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const access = params.get('access')?.trim();
  if (!access) return null;

  const auth: KioskGatewayAuth = {
    accessToken: access,
    pairingCode,
    kioskId: '',
    churchId: '',
  };
  writeGatewayAuth(auth);
  params.delete('access');
  const query = params.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
  return auth;
};
